import StandardGateway from 'scripts/adapters/gateways/lib/standard_gateway';

export const SIDEKICK_FETCH_TIMEOUT = 20000; // 20 seconds to allow fetch external actions

export default class SidekickHttpGateway extends StandardGateway {
  constructor(backend, url) {
    super(backend, url);
  }

  // override the fetchAll method because we need to pass the body in the request
  // body should be passed through the httpOptions
  fetchAll(params, query, httpOptions) {
    const localParams = params;
    const localQuery = query;
    const url = this.buildUrl(this.endpoint.set(params).fetchAllUrl, query);
    const resource = this.endpoint.patterns.fetchAllUrl;

    return this.http
      .post(
        url,
        { ...localParams, nameAsc: true, limit: 750, ...(httpOptions?.body || {}) },
        { headers: { 'X-Method': 'GET' }, timeout: SIDEKICK_FETCH_TIMEOUT, ...(httpOptions?.headers || {}) },
        resource
      )
      .then(dto => {
        this.observer.onFetchAllSuccess(dto, localParams, localQuery);
        return dto;
      })
      .catch(error => {
        this.observer.onFetchAllError(error, localParams, localQuery);
        throw error;
      });
  }
}
